<div class="container">
  <fgb-points-summary-bar
    [marketplaceItemGroup]="marketplaceItemType.group"
  ></fgb-points-summary-bar>
</div>

<div class="container d-none d-lg-block pt-3">
  <div class="back-btn text-white cursor-pointer" (click)="goBack()">
    <span class="material-icons"> arrow_back_ios </span>
  </div>
</div>

<fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
